import React, {Component} from 'react'
import Form from 'procedures/changeDependents/add/Form'
import {connect} from 'react-redux'
import api from 'api'
import {actionCreators} from 'actions'
import withRouterLegacy from 'withRouterLegacy'
import {dependentDefaultValue} from 'employees/form/common'
import {handlerNestFormResponse} from 'libs/errorHandler'
import {toFormValues} from 'utils'
import {asyncError} from 'store/actions/asyncError'

const addEmployeeDependents = (procedureStatus) => {
  const employee_dependents = procedureStatus.employee.employee_dependents
  return procedureStatus.procedure_add_dependents_data.map((add_dependent) => {
    const dependent = employee_dependents.find((dependent) => dependent.id === add_dependent.employee_dependent_id)
    return {...dependent, is_report_target: add_dependent.is_report_target}
  })
}

class Update extends Component {
  componentDidMount() {
    const {
      loadData,
      token,
      match: {
        params: {id},
      },
    } = this.props
    loadData(id, token)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  makeInitialValues() {
    const {procedureStatus} = this.props
    if (!procedureStatus.id) {
      return {dependents: [dependentDefaultValue()]}
    }
    const dependents = addEmployeeDependents(procedureStatus).map(toFormValues)

    return {
      date_on: procedureStatus.date_on,
      dependents,
      marital_status: procedureStatus.employee.marital_status,
      spouse_annual_income: procedureStatus.employee.spouse_annual_income,
      spouse_monthly_income: procedureStatus.employee.spouse_monthly_income,
    }
  }

  render() {
    const {procedureStatus} = this.props
    return (
      <Form
        onSubmit={this.handleSubmit}
        initialValues={this.makeInitialValues()}
        submitText="保存"
        employee={procedureStatus.employee || {}}
      />
    )
  }

  handleSubmit = (values) => {
    const {update, procedureStatus, token, history} = this.props
    return update(procedureStatus, values, token, history)
  }
}

export default withRouterLegacy(
  connect(
    (state) => ({
      procedureStatus: state.procedureStatuses.current.data,
      token: state.auth.token,
    }),
    (dispatch) => ({
      loadData: (id, token) => {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api
              .createWithAuth(token)
              .procedureStatuses.get(id, ['employee', 'employee_dependents', 'procedure_add_dependents_data'])
          )
        )
      },
      destroy: () => {
        dispatch(actionCreators.procedureStatuses.current.destroy())
      },
      update: async (
        procedureStatus,
        {dependents, marital_status, spouse_annual_income, spouse_monthly_income, date_on: dateOn},
        token,
        history
      ) => {
        const authedApi = api.createWithAuth(token)
        try {
          await authedApi.procedureStatuses.update(procedureStatus.id, {date_on: dateOn})
          await authedApi.procedureStatuses.addDependentsData
            .updateAll(procedureStatus.id, dependents)
            .catch(handlerNestFormResponse('dependents'))
          await authedApi.employees.update(procedureStatus.employee_id, {
            marital_status,
            spouse_annual_income,
            spouse_monthly_income,
          })
          history.push(`/procedure_statuses/${procedureStatus.id}`)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )(Update)
)
